<template>
  <div>
    <div class="row">
      <div class="col-12">
        <icon-view
          gradient
          class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
          icon="fas fa-user color-orange mb-1"
          title="Seleccione Categoría(s)"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 border-right">
        <ValidationProvider
          v-slot="{ errors }"
          name="Categoría"
          :rules="categoryValidationRule"
        >
          <custom-drop-down
            v-model="currentCategory"
            :options="availableCategories"
            label="Categoría:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :error="errors[0]"
            custom-error-msg="Debe seleccionar al menos una categoría"
            :disabled="readOnly"
          />
        </ValidationProvider>
        <div class="row mt-3 justify-content-lg-end justify-content-sm-start">
          <div class="col-md-4 text-right">
            <ActionButton
              variant="success"
              text="Añadir"
              i="fas fa-file-plus"
              :disabled="readOnly"
              @click="addCategory"
            />
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-9">
            <CustomChipsGroup
              title="Categorías Seleccionadas"
              :selected-items="model"
              :no-wrap="true"
              no-background
              :object-text="'name'"
              class="mt-n3"
              :disabled="readOnly"
              @itemMarkedForDeletion="removeCategory"
            />
            <error
              v-if="showError"
              message="Favor de seleccionar al menos una categoría"
              variant="no-border"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from "custom-drop-down";
import CustomLink from "@/components/common/CustomLink";
import ActionButton from "@/components/common/ActionButton";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import Error from "@/components/common/Error";
import IconView from "icon-view";
import { getCalendarCategories } from "@/services/operations/dashboard-management";

export default {
  name: "CategorySelection",
  components: {
    CustomDropDown,
    CustomLink,
    ActionButton,
    CustomChipsGroup,
    Error,
    IconView
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    showError: {
      type: Boolean,
      default: () => false
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      currentCategory: null,
      availableCategories: [],
      requiredCategory: false,
      categoryList: []
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    categoryValidationRule() {
      return this.model?.length ? "" : "required";
    },
  },
  watch: {
    categoryList: {
      handler(val) {
        this.availableCategories = val.filter(
          e => !this.model.some(x => e.id === x.id)
        );
      },
      immediate: true
    }
  },
  async mounted() {
    await this.getCategoryTypes();
  },
  methods: {
    addCategory() {
      if (!this.currentCategory) {
        this.requiredCategory = true;
        return;
      }
      this.model.push({ ...this.currentCategory });
      this.availableCategories = this.availableCategories.filter(
        e => e.id !== this.currentCategory.id
      );
      this.currentCategory = null;
      this.requiredCategory = false;
    },
    removeCategory({ id }) {
      this.model = this.model.filter(e => e.id !== id);
      const option = this.categoryList.find(e => e.id === id);
      if (option) this.availableCategories.push(option);
    },
    async getCategoryTypes() {
      const { data } = await getCalendarCategories();
      this.categoryList = data;
    }
  }
};
</script>
